import styled from 'styled-components';

import { mediaQuery } from '../../variables';

export const PageInner = styled.main`
  min-height: 100vh;

  ${mediaQuery.lessThan('desktop')`
    min-height: calc(100vh - 62px);
    margin-left: 0px;
  `}
`;
